import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {BaseModel} from "../models/BaseModel";
import {ContactMethodResponse} from "../models/Common/contactMethodResponse";
import {CurrencyResponse} from "../models/Common/currencyResponse";
import {CountryResponse} from "../models/Common/countryResponse";
import {ApplicationTargetGroupResponse} from "../models/Common/applicationTargetGroupResponse";
import {applicationImpactResponse} from "../models/Common/applicationimpactResponse";
import {cofundingStatusResponse} from "../models/Common/cofundingStatusResponse";
import {emergencyFundTargetResponse} from "../models/Common/emergencyFundTargetResponse";
import {TypeOfSupportResponse} from "../models/Common/typeOfSupportResponse";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) {
  }

  private apiUrl = environment.apiConfig.uri + '/api/common';


  getContactMethod(): Observable<BaseModel<Array<ContactMethodResponse>>> {
    return this.http.get<BaseModel<Array<ContactMethodResponse>>>(`${this.apiUrl}/contactmethod`);
  }

  getCurrency(): Observable<BaseModel<Array<CurrencyResponse>>> {
    return this.http.get<BaseModel<Array<CurrencyResponse>>>(`${this.apiUrl}/currencies`);
  }

  getCountry(): Observable<BaseModel<Array<CountryResponse>>> {
    return this.http.get<BaseModel<Array<CountryResponse>>>(`${this.apiUrl}/countries`);
  }

  getCountryEntity(): Observable<BaseModel<Array<CountryResponse>>> {
    return this.http.get<BaseModel<Array<CountryResponse>>>(`${this.apiUrl}/countriesentity`);
  }

  getIndustriesEntity(): Observable<BaseModel<Array<CountryResponse>>> {
    return this.http.get<BaseModel<Array<CountryResponse>>>(`${this.apiUrl}/industries`);
  }

  getApplicationTarget(): Observable<BaseModel<Array<ApplicationTargetGroupResponse>>> {
    return this.http.get<BaseModel<Array<ApplicationTargetGroupResponse>>>(`${this.apiUrl}/applicationtargetgroup`);
  }

  getApplicationImpact(): Observable<BaseModel<Array<applicationImpactResponse>>> {
    return this.http.get<BaseModel<Array<applicationImpactResponse>>>(`${this.apiUrl}/applicationimpact`);
  }
  getEmergencyFundingTarget(): Observable<BaseModel<Array<emergencyFundTargetResponse>>> {
    return this.http.get<BaseModel<Array<emergencyFundTargetResponse>>>(`${this.apiUrl}/fundingtarget`);
  }

  getCofundingStatus(): Observable<BaseModel<Array<cofundingStatusResponse>>> {
    return this.http.get<BaseModel<Array<cofundingStatusResponse>>>(`${this.apiUrl}/cofundingstatus`);
  }

  getTypeOfSupport(): Observable<BaseModel<Array<TypeOfSupportResponse>>> {
    return this.http.get<BaseModel<Array<TypeOfSupportResponse>>>(`${this.apiUrl}/typeofsupport`);
  }



}
